import '../../styles/styles.scss'
import { setupSubMenus, setupMobileMenu, setupCountryMenu } from './menu'
import { addWaves, setupWaves } from './waves'
import { aniSetup } from './ani'
import { fixChromeBug } from './vid'
import { popupSetup } from './popup'

/**
 * Menu
 */
const menu = document.getElementById('header-menu')
setupSubMenus(menu)
setupMobileMenu(menu)
setupCountryMenu(document.getElementById('country'))

/**
 * Wave animations
 */
addWaves(document.querySelectorAll('.is-style-bg-waves-blue'))
addWaves(document.querySelectorAll('.is-style-bg-waves-blue-light'), 'light-blue')
addWaves(document.querySelectorAll('.is-style-bg-waves-yellow'), 'yellow')
setupWaves(document.querySelectorAll('.waves'))

/**
 * Animations
 */
aniSetup('.ani', ['.ani-able', '.wp-block-column', '.wp-block-button'])

/**
 * Videos
 */
fixChromeBug()

/**
 * Popups
 */
popupSetup()
